import * as React from "react"
import { Box, Badge } from "@mui/material";
import { TooltipSeeker } from "@ui-seeker/core";
import { formatPriceSymbol } from "@ui-seeker/utils";

import {useUserApp} from "@hooks";
import {BadgeVariant} from "@components";


export default function currentPriceColumn() {
	return {
		name: 'currentPrice', label: 'Current Price',
		options: {
			filter: false,
			customBodyRowRender: (value, { currency, currentPriceStock, numVariants }) => <CurrentPriceCell
				value={value}
				currency={currency}
				currentPriceStock={currentPriceStock}
				numVariants={numVariants}
			/>
		}
	}
}

const CurrentPriceCell = ({ value, currency, currentPriceStock, numVariants }) => {
	const { userGroupByProductID } = useUserApp()

	return <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
		<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
			{formatPriceSymbol(value, currency)}
			<TooltipSeeker title={currentPriceStock ? 'In Stock' : 'Out of Stock'} >
				<Badge
					color={currentPriceStock ? 'success' : 'error'}
					badgeContent=""
					sx={{ ml: 2, mr: 1 }}
				/>
			</TooltipSeeker>
			{ !userGroupByProductID && !!currentPriceStock && <BadgeVariant numVariants={numVariants} /> }
		</Box>
	</Box>
}